export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center pt-[72px] bg-background-50">
      <div className="max-w-7xl mx-auto w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full mb-4">
              韩漫 · 日漫 · 国漫
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight">
              爱漫画网 · 免费漫画在线阅读平台
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-medium leading-relaxed">
              下拉式沉浸阅读，每日追更不停歇
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              爱漫画网汇聚海量韩漫、日漫、国漫资源，覆盖恋爱、热血、玄幻、悬疑等全品类题材。支持下拉式沉浸阅读模式，高清画质流畅不卡顿，无需注册即可免费畅读。每日同步更新热门连载，漫画全集一键收藏，手机版与电脑版全平台适配，随时随地享受极致的在线看漫画体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5">
              <div className="flex items-center gap-2 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-foreground-700">超过<strong className="text-foreground-950">20,000部</strong>漫画资源</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="text-foreground-700">每日<strong className="text-foreground-950">200+话</strong>同步更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <span className="text-foreground-700"><strong className="text-foreground-950">免注册</strong>即刻畅读</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                立即开始阅读
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold text-foreground-700 border border-background-300 hover:border-primary-400 hover:text-primary-600 rounded-md transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                查看热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20manga%20reading%20scene%20with%20floating%20comic%20panels%20in%20warm%20amber%20and%20peach%20tones%2C%20Japanese%20manga%20aesthetic%2C%20cozy%20reading%20atmosphere%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20modern%20tablet%20displaying%20colorful%20comic%20pages%2C%20elegant%20composition%2C%20scroll-like%20flowing%20layout&width=1200&height=900&seq=hero-main&orientation=landscape"
                alt="爱漫画网 - 免费漫画在线看，下拉式沉浸阅读体验"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}